import { ExcelDataLinkingStore } from "./store";

export function initExcelDataLinkingStore() {
    new ExcelDataLinkingStore();
}
